var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAm001XUncheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 20,
    height: 20,
    rx: 3,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.144 16V15.482L9.938 10.96L6.144 6.438V5.92H8.146L11.17 9.504L14.166 5.92H16.182V6.438L12.374 10.96L16.182 15.468V16H14.166L11.156 12.43L8.146 16H6.144Z",
    fill: "#222222"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 20,
    height: 20,
    rx: 3,
    stroke: "#E7ECEF",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAm001XUncheck);
export default __webpack_public_path__ + "static/media/am-001-x-uncheck.3cb56da7208b6289c41feb29cf819814.svg";
export { ForwardRef as ReactComponent };